var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130.4 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--groups",
    x1: 3.43,
    y1: -547.12,
    x2: 28.67,
    y2: -572.36,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -543.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff962d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc7638"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "groups-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.7,7.5h-.9a.7.7,0,0,0-.7.7l-.3.7a7.9,7.9,0,0,0-4.9-1.7c-4.1,0-7.4,3.6-7.4,8.2s3.3,8.3,7.6,8.3a8.6,8.6,0,0,0,3.8-1v.5c0,3.3-2,4-3.7,4a6.4,6.4,0,0,1-3.5-1.4,1,1,0,0,0-.7-.2c-.3.1-.5.2-.6.5l-.8,1.4a.9.9,0,0,0,.2,1.1,8.5,8.5,0,0,0,5.5,2c4.5,0,7.3-2.8,7.3-7.4V8.4A.9.9,0,0,0,53.7,7.5Zm-2.8,5.3V19a6,6,0,0,1-3.4,1.1,4.5,4.5,0,0,1-4.3-4.7,4,4,0,0,1,3.6-4.6,4,4,0,0,1,4.1,2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,8.1c-.4-.7-1.8-.9-3-.9a6,6,0,0,0-4.6,2.1l-.3-1.1a1,1,0,0,0-.9-.7h-.8a.9.9,0,0,0-.9.9v14a.9.9,0,0,0,.9.9h1.6c.5,0,1.2,0,1.2-.9V12.7a4.6,4.6,0,0,1,3.5-2,3.1,3.1,0,0,1,1.3.3h.7a1.2,1.2,0,0,0,.5-.5l.8-1.7A1.1,1.1,0,0,0,68.1,8.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,7.2a8.2,8.2,0,0,0-8.4,8,8.1,8.1,0,0,0,8,8.5,8.2,8.2,0,0,0,8.4-8v-.3A8.1,8.1,0,0,0,75.8,7.2Zm4.4,8.2a4.4,4.4,0,1,1-8.8.6v-.6a4.4,4.4,0,0,1,8.8,0Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,7.5H96.8c-.6,0-1.1.1-1.1.9v9.4a3.6,3.6,0,0,1-3.4,2.3c-1.9,0-2.8-1.1-2.8-3.4V8.4a1.1,1.1,0,0,0-1-.9H86.7a.9.9,0,0,0-.9.9v8c0,3.4.6,7.3,5.9,7.3a6.7,6.7,0,0,0,4.8-2l.3.9a.9.9,0,0,0,.9.7h.8a.9.9,0,0,0,.9-.9V8.4A.9.9,0,0,0,98.5,7.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1,7.2a7.6,7.6,0,0,0-4.8,1.7l-.3-.8a.9.9,0,0,0-.8-.6h-.9a1,1,0,0,0-.9.9V29.5a.9.9,0,0,0,.9.9h1.9a.9.9,0,0,0,1-.8h0V22.7a10.2,10.2,0,0,0,3.8,1c4.2,0,7.6-3.7,7.6-8.3S114.3,7.2,110.1,7.2Zm3.8,8.2a4.5,4.5,0,0,1-4.3,4.7h-.1a5.9,5.9,0,0,1-3.4-1V12.7a4.3,4.3,0,0,1,3.6-2c2.4,0,4.2,2,4.2,4.7Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,13.7c-1.6-.7-2.5-1.2-2.5-2.1s.5-1.2,1.8-1.2a7.2,7.2,0,0,1,3.2.8,1,1,0,0,0,1.2-.4h0l.6-1.1a1.2,1.2,0,0,0-.4-1.4,8.3,8.3,0,0,0-4.6-1.1c-3.7,0-5.3,2.2-5.3,4.4s2,4,4.3,5,3.2,1.6,3.2,2.5-.7,1.3-1.9,1.3a6.9,6.9,0,0,1-3.7-1h0a1.2,1.2,0,0,0-.8-.1,1,1,0,0,0-.5.4l-.7,1.4a.9.9,0,0,0,.3,1.1h0a9.6,9.6,0,0,0,5.2,1.6c3.7,0,5.7-2.4,5.7-4.7S127.9,15,124.8,13.7Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,16c0,12.4-3.1,15.5-15.5,15.5S.5,28.4.5,16,3.6.5,16,.5,31.5,3.6,31.5,16Z",
    fill: "url(#linear-gradient--groups)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,12.4H13.9A2.6,2.6,0,0,1,12.4,14v4.1a2.5,2.5,0,0,1,1.5,1.5H18a2.9,2.9,0,0,1,1.6-1.5V13.9A2.3,2.3,0,0,1,18.1,12.4Zm5.5,8.3a2.9,2.9,0,0,1-2.9,2.9A3.1,3.1,0,0,1,18,21.9H13.9a2.9,2.9,0,0,1-5.3-2.3A2.9,2.9,0,0,1,10.1,18V14a3.1,3.1,0,0,1-1.5-3.9,2.9,2.9,0,0,1,3.8-1.5,2.5,2.5,0,0,1,1.5,1.5h4.2A2.9,2.9,0,1,1,21.9,14v4a3.1,3.1,0,0,1,1.7,2.7Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsBadgeColor);
export default __webpack_public_path__ + "static/media/groups-badge-color.25953f564d24a7bc72ab51f85f0863b2.svg";
export { ForwardRef as ReactComponent };